<template>
    <q-drawer v-model="drawer" :width="$q.screen.lt.md ? 300 : 260" overlay behavior="mobile" class="bg-white">
        <div class="drawer-header q-pa-md">
            <div class="q-mt-sm">
                <img src="../../assets/SERA_LOGO.png" />
                <div class="text-caption text-weight-bold text-white eyebrow">SERA PAKISTAN</div>
            </div>
        </div>

        <q-list padding>
            <q-item
                v-for="(menu, i) in $store.state.menus"
                :key="i"
                class="menu-item"
                @click="handleRoute(menu)"
                clickable
                v-ripple
                active-class="active-menu-item"
            >
                <q-item-section class="menu-icon" avatar><q-icon name="dashboard" /></q-item-section>
                <q-item-section>{{ menu.menuName }}</q-item-section>
            </q-item>
            <q-separator class="" />
            <q-separator class="" />
            <q-item class="menu-item" @click="logout" clickable v-ripple>
                <q-item-section class="menu-icon" avatar><q-icon name="logout" /></q-item-section>
                <q-item-section>Logout</q-item-section>
            </q-item>
        </q-list>
    </q-drawer>
</template>

<script>
// import { v4 as uuidV4 } from 'uuid';
export default {
    props: ['isShow'],
    name: 'MainLayout',
    data() {
        return {
            drawer: false,
        };
    },
    methods: {
        toggleDrawer() {
            this.drawer = !this.drawer;
        },
        logout() {
            this.$store.commit('logOutHandler');
            // this.$router.push('/login');
        },

        handleRoute(menu) {
            console.log('menu: ', menu);
            if (menu.menuName === 'Dashboard') {
                this.$router.push('/').catch(() => {});
            } else this.$router.push(menu.menuUrl).catch(() => {});
            this.$store.commit('setMenu', menu)
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/quasar.scss';
.drawer-header {
    // background: $primary-gradient;
     background: linear-gradient(135deg, #106ca7 0%, #90d1fd 50%, #186189 100%);
    margin-bottom: 8px;
}

.active-menu-item {
    color: $primary;
    background: rgba(13, 92, 99, 0.08);
    font-weight: 600;
}
.eyebrow {
    opacity: 0.75;
}

.brand-mark {
    width: 42px;
    height: 42px;
    flex: 0 0 auto;
    display: grid;
    place-items: center;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.16);
}
.menu-item {
    color: #000;
}
.menu-icon {
    color: $primary;
}

@media (max-width: 641px) {
    .menu-item {
        // color: #0d5c63;
        // background: rgba(13, 92, 99, 0.08);
        // font-weight: 600;
        color: #000;
        font-size: 18px;
        padding-top: 15px;
        padding-bottom: 15px;
    }
}
</style>